import React, {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import PropTypes from 'prop-types';

import {TAGS} from '../utils/constants';
import LoadingIndicator from '../../../../../../Common/LoadingIndicator';

import TagList from './TagsList';

const TagsPanel = ({values, errors, handleChange, handleSubmit, handleReset, isLoading, setIsLoading}) => {
	const tagsStore = useSelector((store) => store.project.tags);

	useEffect(() => {
		if (values[TAGS] === null) handleChange(TAGS, tagsStore);
	}, [tagsStore]);

	const renderTags = () => {
		const id = TAGS;
		const props = {
			handleChange: handleChange,
			tagsList: values[id]
		};

		return <TagList {...props} />;
	};

	return (
		<>
			{values[TAGS]?.length < 0 || (values[TAGS] === null && <LoadingIndicator show />)}
			{renderTags()}
		</>
	);
};
TagsPanel.propTypes = {
	values: PropTypes.objectOf(PropTypes.any),
	handleChange: PropTypes.func.isRequired
};

export default TagsPanel;
